import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_STATE_TYPES } from '../../task-state/store'

export default {
  name: 'TaskChoicesMixin',
  computed: {
    ...mapGetters({
      taskStateList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.GETTERS.list
    }),
    taskStateEntries () {
      if (!this.taskStateList || !this.taskStateList.results) return []
      return this.taskStateList.results.filter((item) => item.status !== 0)
    },
    stateOptions () {
      return this.taskStateEntries.map(
        (item) => ({ value: item.id, text: item.name, color: item.color || '#6c757d' })
      )
    }
  },
  methods: {
    ...mapActions({
      fetchTaskStateList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.ACTIONS.setFilters
    }),
    getStateDisplay (value) {
      const match = this.taskStateEntries.find((i) => i.id === value)
      return match ? match.name : value
    },
    getStateCode (value) {
      const match = this.taskStateEntries.find((i) => i.id === value)
      return match ? match.code : null
    },
    getStateIdByCode (code) {
      const match = this.taskStateEntries.find((i) => i.code === code)
      return match ? match.id : null
    },
    fetchTaskChoices () {
      return this.fetchTaskStateList({ filter__status: 1 })
    }
  }
}
